import React from "react";
import { Icon, IconProps } from "@chakra-ui/react";

interface IconExtProps extends IconProps {
  dark?: boolean;
}
export const CloseIcon: React.FC<IconExtProps> = (props) => {
  return (
    <Icon w="12px" h="12px" viewBox="0 0 12 12" {...props}>
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.17789 5.99956L11.5887 1.58872C11.9146 1.26289 11.9146 0.736224 11.5887 0.410391C11.2629 0.0845573 10.7362 0.0845573 10.4104 0.410391L5.99956 4.82122L1.58872 0.410391C1.26289 0.0845573 0.736224 0.0845573 0.410391 0.410391C0.0845573 0.736224 0.0845573 1.26289 0.410391 1.58872L4.82122 5.99956L0.410391 10.4104C0.0845573 10.7362 0.0845573 11.2629 0.410391 11.5887C0.572891 11.7512 0.786224 11.8329 0.999557 11.8329C1.21289 11.8329 1.42622 11.7512 1.58872 11.5887L5.99956 7.17789L10.4104 11.5887C10.5729 11.7512 10.7862 11.8329 10.9996 11.8329C11.2129 11.8329 11.4262 11.7512 11.5887 11.5887C11.9146 11.2629 11.9146 10.7362 11.5887 10.4104L7.17789 5.99956Z"
          fill="#353F50"
        />
      </svg>
    </Icon>
  );
};
